import React, { useState, useEffect,useRef } from 'react';
import API_BASE_URL from '../../config';
import PropTypes from 'prop-types';
import {
  Container,
  Segment,
  Header,
  Radio,
  Button,
  Message,
  Icon,
  Divider
} from 'semantic-ui-react';
import axios from 'axios';

const TieBreaker = ({ questions, sessionId, onComplete, userInfo, tempResultData }) => {
  const [filteredQuestions, setFilteredQuestions] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const hasRunRef = useRef(false);

  useEffect(() => {
    if (hasRunRef.current) return;
    if (!tempResultData || !questions?.length) return;
  
    const counts = {};
  
    tempResultData.questionsAndAnswers.forEach((entry) => {
      const typeId = entry.selectedPersonType;
      const count = entry.selectedOptionIds.length;
      counts[typeId] = (counts[typeId] || 0) + count;
    });
  
    const maxCount = Math.max(...Object.values(counts));
    const topTypes = Object.entries(counts)
      .filter(([_, count]) => count === maxCount)
      .map(([typeId]) => parseInt(typeId));
  
      if (topTypes.length === 1) {
        //console.log("✅ Tie-breaker gerekmedi, otomatik geçiliyor.");
        hasRunRef.current = true;
      
        // ✅ sadece bir kere onComplete çağrılmasını garanti et
        setTimeout(() => {
          onComplete();
        }, 100);
        return;
      }
      
    const filtered = questions.map((q) => ({
      ...q,
      options: q.options.filter((opt) => topTypes.includes(opt.personality_type_id)),
    })).filter(q => q.options.length > 0);
  
    //console.log("🎯 Filtrelenmiş tie-breaker soruları:", filtered);
    setFilteredQuestions(filtered);
    hasRunRef.current = true;
  }, [tempResultData, questions, onComplete]);


  const currentQuestion = filteredQuestions[currentIndex];

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
  };

  const handleNext = () => {
    if (!selectedOption) return;

    const answer = {
      personality_type_id:
        selectedOption?.personality_type_id ||
        selectedOption?.personality_type ||
        selectedOption?.id,
      order: currentIndex + 1,
    };

    const updatedAnswers = [...answers, answer];
    setAnswers(updatedAnswers);
    setSelectedOption(null);

    if (currentIndex < filteredQuestions.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      submitAnswers(updatedAnswers);
    }
  };

  const submitAnswers = async (finalAnswers) => {
    setSubmitting(true);

    try {
      const payload = {
        session_id: sessionId,
        answers: finalAnswers.map((ans) => ({
          personality_type_id: ans.personality_type_id,
          order: ans.order,
        })),
      };

      //console.log("📤 TieBreaker Submit Payload:", payload);
      await axios.post(`${API_BASE_URL}/api/tiebreaker/`, payload);
      onComplete();
    } catch (err) {
      console.error("❌ Tie-breaker gönderimi başarısız:", err);
    } finally {
      setSubmitting(false);
    }
  };

  if (filteredQuestions.length === 0) return null;

  return (
    <Container>
      <Segment>
        <Header as="h2" textAlign="center" style={{ marginBottom: 30 }}>
          {currentQuestion?.question || 'Sizi en iyi tanımlayan ifadeyi seçin'}
        </Header>
        <Message floating size="large" icon>
          <Icon name="question circle outline" />
          <Message.Content>
  <Message.List>
    <Message.Item><strong>İsim:</strong> {userInfo.full_name}</Message.Item>
    <Message.Item><strong>Email:</strong> {userInfo.email}</Message.Item>
  </Message.List>

  <Divider />

  <div style={{
    fontSize: '1rem',
    lineHeight: 1.6,
    color: '#555',
    padding: '0.5rem 1rem',
    maxWidth: '100%',
    wordBreak: 'break-word',
  }}>
    <p>
      Her cümle size yakın gelebilir. Çünkü bu ifadeler sizde az ya da çok bulunur.
    </p>
    <p>
      <strong>Aşağıdaki ifadelerden sizi %100 TANIMLAYAN ifadeleri işaretlemenizi istiyoruz.</strong>
      <strong style={{ marginLeft: '0.3rem' }}> BİRDEN FAZLA İFADE </strong> işaretleyebilirsiniz.
    </p>
    <p>
      Ancak <strong>sizi AZ TANIMLAYAN</strong> İFADELERİ İŞARETLEMEYİNİZ.
    </p>
    <p>
      Her ifadenin sizde var olabileceğini hatırlatalım ama amacınız <em>sizi en iyi tanımlayan ifadeleri</em> bulmak. 😊
    </p>
  </div>
</Message.Content>

        </Message>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
          {(currentQuestion.options || [])
            .slice()
            .sort((a, b) => a.personality_type_id - b.personality_type_id)
            .map((option) => (
              <Radio
                key={`${currentIndex}-${option.id}`}
                label={
                  <label style={{ fontWeight: 'bold', cursor: 'pointer' }}>
                    {option.text}
                  </label>
                }
                name={`question-${currentIndex}`}
                value={option.id}
                checked={selectedOption?.id === option.id}
                onChange={() => handleOptionSelect(option)}
                style={{ marginBottom: 10 }}
              />
            ))
          }
        </div>

        <Button
          primary
          disabled={!selectedOption || submitting}
          onClick={handleNext}
          style={{ marginTop: 30 }}
          size="large"
          fluid
        >
          {currentIndex === filteredQuestions.length - 1 ? 'Sonucu Gör' : 'Devam Et'}
        </Button>

        {submitting && (
          <Message info style={{ marginTop: 20 }}>
            Gönderiliyor, lütfen bekleyin...
          </Message>
        )}
      </Segment>
    </Container>
  );
};

TieBreaker.propTypes = {
  questions: PropTypes.array.isRequired,
  sessionId: PropTypes.string.isRequired,
  onComplete: PropTypes.func.isRequired,
  userInfo: PropTypes.object.isRequired,
  tempResultData: PropTypes.object.isRequired,
};

export default TieBreaker;
















